module.exports = __webpack_public_path__ + "img/ketupat.3f40f210.png";